<template>
  <div>
    <div class="modal-header">
      <h2>{{ member.user_full_name }}</h2>
    </div>
    <div class="body">
      <p>
        Datom članu će biti odobren ulazak u zajednicu.
        <br />Ukoliko želite, možete promeniti i stan koji je korisnik odabrao
        pri prijavi u zajednicu.
        <br />
        Trenutni stan je: '{{ member.div_desc }}'.
      </p>
      <p></p>

      <form class="form--mod" action="post">
        <br />
        <label class="col-form-label col-form-label-md">Stan</label>
        <select
          class="form-control custom-select to"
          v-model="member.property_id"
        >
          <option
            v-for="property of allProperties"
            :key="property.id"
            v-bind:value="property.id"
            >{{ property.description }}</option
          >
        </select>
      </form>
    </div>

    <hr />
    <div class="footer">
      <button class="btn btn-danger btn--mod" @click="closeModal">
        Otkaži
      </button>
      <button
        class="btn btn-primary btn--mod"
        @click="acceptMember"
        :disabled="loading"
      >
        <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        <span v-if="!loading">
          Pošalji
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('modal', ['member', 'allProperties'])
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('table', ['getPendingMembersByCommunity']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    acceptMember() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      // TODO Remove this when backend does
      const property = this.allProperties.find(
        p => p.id == this.member.property_id
      );
      // also remove voting_points from acceptRequest
      if (this.member.voting_points != null) {
        let acceptRequest = {
          communityId: this.member.community_id,
          memberId: this.member.id,
          propertyId: this.member.property_id
        };
        axios
          .post('/member/approve', acceptRequest)
          .then(() => {
            this.getPendingMembersByCommunity(this.$route.params.id);
            this.loading = false;
            this.closeModal();
            this.showSuccessModal();
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.showFailModal();
          });
      }
    }
  }
};
</script>

<style scoped></style>
